(() => {
  let loaded = false;

  const loadClarity = () => {
    if (loaded) return;
    loaded = true;

    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/xfjzf3ho2y';
    document.head.appendChild(script);
  };

  ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, loadClarity, { once: true, passive: true });
  });

  window.addEventListener(
    'load',
    () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadClarity, { timeout: 4500 });
      } else {
        window.setTimeout(loadClarity, 3500);
      }
    },
    { once: true }
  );
})();
